function bindColorSwatches() {
  // Select all color swatch buttons
  const colorSwatches = document.querySelectorAll(".color-swatch");

  colorSwatches.forEach((swatch) => {
    swatch.removeEventListener("click", handleSwatchClick); // Prevent duplicate listeners
    swatch.addEventListener("click", handleSwatchClick);
  });
}

function handleSwatchClick(e) {
  e.preventDefault(); // Prevent any default behavior

  // Get the new image src and srcset from data attributes
  const newSrc = this.getAttribute("data-src");
  const newSrcSet = this.getAttribute("data-srcset");

  // Find the product card and its image element
  const productCard = this.closest(".card-wrapper");
  const productImage = productCard.querySelector(".card-image");

  if (productImage && newSrc && newSrcSet) {
    productImage.src = newSrc; // Update src attribute
    productImage.srcset = newSrcSet; // Update srcset attribute
    productImage.alt = "Selected variant image"; // Optional: Update alt text
  }

  // // Highlight the active swatch
  // const allSwatches = productCard.querySelectorAll(".color-swatch");
  // allSwatches.forEach((s) => s.classList.remove("active"));
  // this.classList.add("active");
}


$(document).ready(function () {

   // Initial binding for swatches
  bindColorSwatches();
});